/** Current timestamp so demo data always looks recent. */
export const now = new Date().toISOString();
